import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { PlayPage } from "./pages/PlayPage";
import { ResultPage } from "./pages/ResultPage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { PricingPage } from "./pages/PricingPage";
import { TermsPage } from "./pages/TermsPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { RefundPage } from "./pages/RefundPage";
import { ChallengePage } from "./pages/ChallengePage";
import { AccountPage } from "./pages/AccountPage";
import { LeaguesPage } from "./pages/LeaguesPage";
import { LeagueDetailPage } from "./pages/LeagueDetailPage";
import { LeagueJoinPage } from "./pages/LeagueJoinPage";
import { AdminPage } from "./pages/AdminPage";
import { GlobalUserPill } from "./components/GlobalUserPill";
import { SiteFooter } from "./components/SiteFooter";
import { WorldCupCountdown } from "./components/WorldCupCountdown";

/**
 * Root layout — mounts the global UserPill in the top-right corner of
 * every route so the sign-in entry is reachable from any page (previously
 * users had to detour through /play to find it). GlobalUserPill suppresses
 * itself on /play, which has its own embedded pill in the canvas toolbar.
 *
 * Everything inside <Outlet /> is the matched child route element.
 */
function RootLayout() {
  return (
    <>
      <GlobalUserPill />
      <WorldCupCountdown />
      <Outlet />
      <SiteFooter />
    </>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/play", element: <PlayPage /> },
      { path: "/result", element: <ResultPage /> },
      { path: "/leaderboard", element: <LeaderboardPage /> },
      { path: "/pricing", element: <PricingPage /> },
      { path: "/terms", element: <TermsPage /> },
      { path: "/privacy", element: <PrivacyPage /> },
      { path: "/refund", element: <RefundPage /> },
      { path: "/c/:attemptId", element: <ChallengePage /> },
      // /account is the post-checkout landing page (?upgrade=success&provider=...)
      // AND the standalone subscription dashboard accessible from the user menu.
      // Without this route the server's checkout return_url goes nowhere.
      { path: "/account", element: <AccountPage /> },
      // Friend Leagues (Plan B-V4). /leagues is the user-facing index; the
      // short /league/<code> form is the shareable join URL the server returns
      // from create-league, optimised for WhatsApp / Messages legibility.
      { path: "/leagues", element: <LeaguesPage /> },
      { path: "/leagues/:id", element: <LeagueDetailPage /> },
      { path: "/league/:code", element: <LeagueJoinPage /> },
      // Operator dashboard — gated server-side by requireAdmin. The page itself
      // renders for anyone; the API just returns 403 and we show a clear message.
      { path: "/admin", element: <AdminPage /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
